import { PageLocatorMap } from '../types/PageLocatorMap';

export const signUpPinVerifyPage = {
  alert: {
    error: 'signup-pin-verify-page.alert.error',
    success: 'signup-pin-verify-page.alert.success',
  },
  footer: {
    root: 'signup-pin-verify-page.footer.root',
  },
  form: {
    h1: 'signup-pin-verify-page.form.heading1',
    h3: 'signup-pin-verify-page.form.heading3',
    pinInput: (position: number): string =>
      `signup-pin-verify-page.form.pin-input-${position}`,
    pinInputError: 'signup-pin-verify-page.form.pin-error',
    resendPinLink: 'signup-pin-verify-page.form.resend-pin-link',
    root: 'signup-pin-verify-page.form.root',
  },
  header: {
    signUpLink: 'signup-pin-verify-page.header.signup-link',
  },
} as const satisfies PageLocatorMap;
